import {get, postJson, deleteApi, post } from '../axios'

/**
 * 根据过滤条件、维度、度量查询报表数据
 * @param {*} p 
 * @returns 
 */
export const conditionList = p => postJson('/bi-custom-report/data/condition', p)


/**
 * 保存/编辑自定义报表配置信息
 * @param {*} p 
 * @returns 
 */
export const conditionSave = p => postJson('/bi-custom-report/save', p)


/**
 * 查询自定义报表详情
 * @param {*} id 
 * @returns 
 */
export const idDetail = id => get(`/bi-custom-report/detail/${id}`)


/**
 * 根据自定义报表ID查询报表数据
 * @param {*} p 
 * @returns 
 */
export const idList = p => get('/bi-custom-report/data/by-id', p)


/**
 * 自定义报表列表查询
 * @param {*} p 
 * @returns 
 */
export const exportList = p => postJson('/bi-custom-report/page', p)


/**
 * 删除自定义报表
 * @param {*} id 
 * @returns 
 */
export const exportDelete = id => deleteApi(`/bi-custom-report/del/${id}`)


/**
 * 查询自定义报表菜单
 * @param {*} p 
 * @returns 
 */
export const exportMenu = p => get('/bi-custom-report/menu-list', p)


/**
 * 根据自定义报表ID导出报表数据
 * @param {*} p 
 * @returns 
 */
export const exportIdList = p => postJson(`/bi-custom-report/data/by-id/export`, p);

/**
 * 查询店铺数据
 * @param {*} p 
 * @returns 
 */
export const selectMarketList = (p) => get(`/common/getCrmData`, {});

/**
 * 查找映射表路由
 * @param {*} buriedPointMap  映射表
 * @param {*} firstLevelName 一级菜单
 * @param {*} secondLevelClassify  二级菜单
 * @returns 
 */
export const findMenuItem = (buriedPointMap, firstLevelName, secondLevelClassify) => {
    // 获取一级菜单对应的数组
    const firstLevelItems = buriedPointMap[firstLevelName];
    if (!firstLevelItems) {
        return null; // 如果没有找到一级菜单，返回 null
    }

    // 遍历二级菜单项，查找匹配的 secondClassify
    for (const item of firstLevelItems) {
        if (item.secondClassify === secondLevelClassify) {
            return item.name; // 返回匹配项的名称
        }
    }

    return null; // 如果没有找到匹配的二级菜单，返回 null
}

/**
 * 查询数据大屏信息
 * @returns 
 */
export const getEchartsData = (p) => postJson(`/bi-main-analysis/monitor-map`, p);